import UserService from '@/services/user';
import MaksimumSubmissionsService from '@/services/maksimumSubmissions';
import { userHaveRoles } from '@/services/utilities';

export default {
	namespaced: true,
	state: {
	},

	getters: {   
		async getUsersUnverified({ commit, state, getters, dispatch }) {
			try {
				// const userLogin = JSON.parse(window.localStorage.getItem('user_data'))
				let response
				if (!userHaveRoles(["super_admin"])) {
					response = await UserService.getUsers()
				} else {
				response = await UserService.getUsersUnverified()
				}

				return response
			} catch (e) {
				console.log(e)
			}
		},
		async getRoles({ commit, state, getters, dispatch }) {
			try {
				const response = await UserService.getRoles()
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async roleUnverified({ commit, state, getters, dispatch }) {
			try {
				const response = await UserService.roleUnverified()
				return response
			} catch (e) {
				console.log(e)
			}
		},
	},

	actions: {
		async getUsers({ commit, state, getters, dispatch }, page) {
			try {
				let response
				if (userHaveRoles(["super_admin"])) {
					response = await UserService.getUsers(page)
				} else {
					response = await UserService.getUsersCompany(page)
				}
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async logIn({ commit, state, getters, dispatch }, payload) {
			// const { email, password } = payload;

			// const response = await UserService.logIn(email, password);

			// if (!response.data.success) {
			// 	return response;
			// } else {
			// 	window.localStorage.setItem('access_token', response.data.attributes.token);
			// 	return response;
			// }
			return 'successfull'
		},
		async createUser({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await UserService.createUser({
					...payload,
					role_id: payload.roles[0].id,
					activated: true,
				});
			} catch (e) {
				console.log(e)
			}
			return response;
		},
		async createUserSubmission({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await UserService.createUser({
					...payload,
					role_id: payload.roles[0].id,
					activated: false,
				});
			} catch (e) {
				console.log(e)
			}
			return response;
		},
		async registrasi({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await UserService.registrasi(payload);
			} catch (e) {
				console.log(e)
			}
			return response;
		},
		
		async updateUser({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await UserService.updateUser({
					...payload,
					role_id: payload.roles[0].id
				});
			} catch (e) {
				console.log(e);
			}
			return response
		},
		async deleteUser({ commit, state, getters, dispatch }, id) {
			try {
				await UserService.deleteUser(id);
			} catch (e) {
				console.log(e);
			}
		},
		async activatedUser({ commit, state, getters, dispatch }, id) {
			try {
				await UserService.activatedUser(id);
			} catch (e) {
				console.log(e);
			}
		},
		async changePassword({ commit, state, getters, dispatch }, payload) {
			let response;
			try {
				response = await UserService.changePassword(payload);
			} catch (e) {
				console.log(e);
			}
			return response;
    },
    async changePasswordFromEmail({ commit, state, getters, dispatch }, payload) {
      let response;
      try{
        response = await UserService.changePasswordFromEmail(payload);
      }catch(e) {
        console.log(e)
      }
      return response;
    },
		async getUserById({ commit, state, getters, dispatch }, id) {
			try {
				let response = await UserService.getUserById(id)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async getUserByName({commit, state, getters, dispatch}, payload){
			try{
				let response = await UserService.getUserByName({q: payload.name})
				return response
			}catch(e){
				console.log(e)
			}
    },
    async verymail({ commit, state, getters, dispatch }, payload) {
      let response;
      try{
        response = await UserService.verymail(payload);
      }catch(e) {
        console.log(e)
      }
      return response;
    },
		async getUsersByEmailOrPhone({ commit, state, getters, dispatch }, query) {
			try {
				let response = await UserService.getUsersByEmailOrPhone(query)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async getMaksimumSubmissions({commit, state, getters, dispatch}){
			try{
				const response = await MaksimumSubmissionsService.getMaksimumSubmissions();
				return response
			}catch(e){
				console.log(e)
			}
		},
		async updateMaksimumSubmissionsItems({commit, state, getters, dispatch}, payload){
			try{
				const response = await MaksimumSubmissionsService.updateMaksimumSubmissionsItems(payload.id, {
					...payload
				})
				return response
			}catch(e){
				console.log(e)
			}
    },
    async toggleUserNotificationStatus({commit, state, getters, dispatch}, payload) {
      try{
				const response = await UserService.toggleUserNotificationStatus({
					...payload
				})
				return response
			}catch(e){
				console.log(e)
			}
    },
		async userProfile({commit, state, getters, dispatch}) {
			try {
				const userLogin = JSON.parse(window.localStorage.getItem('user_data'))
				let response = await UserService.me();
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async updateUserProfile({commit, state, getters, dispatch}, payload) {
			try{
				const response = await UserService.updateUserProfile({
					...payload
				});

				return response
			}catch(e){
				console.log(e)
			}
		},
		async uploadImageProfile({commit, state, getters, dispatch}, payload) {
			try{
				const response = await UserService.uploadImageProfile(payload);
				return response
			}catch(e){
				console.log(e)
			}
		},
		async uploadImageSelfie({commit, state, getters, dispatch}, payload) {
			try{
				const response = await UserService.uploadImageSelfie(payload);
				return response
			}catch(e){
				console.log(e)
			}
		},
		async uploadImageIdentitas({commit, state, getters, dispatch}, payload) {
			try{
				const response = await UserService.uploadImageIdentitas(payload);
				return response
			}catch(e){
				console.log(e)
			}
		},
		async uploadImageNPWP({commit, state, getters, dispatch}, payload) {
			try{
				const response = await UserService.uploadImageNPWP(payload);
				return response
			}catch(e){
				console.log(e)
			}
		},
		async updateImageProfile({commit, state, getters, dispatch}, payload) {
			try{
				const response = await UserService.updateImageProfile(payload);
				return response
			}catch(e){
				console.log(e)
			}
		},
		async removeImageProfile({commit, state, getters, dispatch}, payload) {
			try{
				const response = await UserService.removeImageProfile(payload);
				return response
			}catch(e){
				console.log(e)
			}
    },
    async verifyEmail({ commit, state, getters, dispatch }, payload) {
      try {
				const response = await UserService.verifyEmail(payload)
				return response
			} catch (e) {
				console.log(e)
			}
    }
	},

	mutations: {
		// SET_VALUE_FROM_API(state, payload) {
		// 	state.valueFromApi = payload;
		// }
	}
};
